export default __webpack_public_path__ + "static/media/more-3.18552b04.svg";